import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Mail, Phone, ArrowRight, ShieldCheck } from 'lucide-react';
import { useNavigation } from '../context/NavigationContext';
import { Screen } from '../types';
import { Header } from '../components/ui/Header';
import { Button } from '../components/ui/Button';
export function VendorVerifyScreen() {
  const {
    navigate
  } = useNavigation();
  const [method, setMethod] = useState<'email' | 'phone'>('email');
  const [otp, setOtp] = useState(['', '', '', '', '', '']);
  const [timeLeft, setTimeLeft] = useState(60);
  useEffect(() => {
    if (timeLeft > 0) {
      const timer = setTimeout(() => setTimeLeft(timeLeft - 1), 1000);
      return () => clearTimeout(timer);
    }
  }, [timeLeft]);
  const handleOtpChange = (index: number, value: string) => {
    if (value.length > 1) value = value[0];
    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);
    // Auto-focus next input
    if (value && index < 5) {
      const nextInput = document.getElementById(`otp-${index + 1}`);
      nextInput?.focus();
    }
  };
  const handleVerify = () => {
    if (otp.join('').length === 6) {
      navigate(Screen.VENDOR_DASHBOARD);
    }
  };
  return <div className="min-h-full bg-white dark:bg-gray-900" data-id="element-2556">
      <Header title="Verify Account" showBack data-id="element-2557" />

      <div className="p-6" data-id="element-2558">
        <div className="flex justify-center mb-6" data-id="element-2559">
          <div className="w-20 h-20 bg-primary/10 rounded-full flex items-center justify-center" data-id="element-2560">
            <ShieldCheck className="w-10 h-10 text-primary" data-id="element-2561" />
          </div>
        </div>

        <h2 className="text-2xl font-bold text-center text-gray-900 dark:text-white mb-2" data-id="element-2562">
          Verification Code
        </h2>
        <p className="text-center text-gray-500 dark:text-gray-400 mb-8" data-id="element-2563">
          We've sent a 6-digit verification code to your{' '}
          {method === 'email' ? 'email' : 'phone'}.
          <br data-id="element-2564" />
          <span className="font-medium text-gray-900 dark:text-gray-200" data-id="element-2565">
            {method === 'email' ? 'j***@example.com' : '+234 800 *** **00'}
          </span>
        </p>

        <div className="flex bg-gray-100 dark:bg-gray-800 p-1 rounded-xl mb-8" data-id="element-2566">
          <button onClick={() => setMethod('email')} className={`flex-1 flex items-center justify-center gap-2 py-2 rounded-lg text-sm font-medium transition-colors ${method === 'email' ? 'bg-white dark:bg-gray-700 text-primary shadow-sm' : 'text-gray-500 dark:text-gray-400'}`} data-id="element-2567">
            <Mail className="w-4 h-4" data-id="element-2568" /> Email
          </button>
          <button onClick={() => setMethod('phone')} className={`flex-1 flex items-center justify-center gap-2 py-2 rounded-lg text-sm font-medium transition-colors ${method === 'phone' ? 'bg-white dark:bg-gray-700 text-primary shadow-sm' : 'text-gray-500 dark:text-gray-400'}`} data-id="element-2569">
            <Phone className="w-4 h-4" data-id="element-2570" /> Phone
          </button>
        </div>

        <div className="flex justify-between gap-2 mb-8" data-id="element-2571">
          {otp.map((digit, index) => <input key={index} id={`otp-${index}`} type="number" maxLength={1} value={digit} onChange={e => handleOtpChange(index, e.target.value)} className="w-12 h-14 text-center text-2xl font-bold bg-gray-50 dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-xl focus:ring-2 focus:ring-primary focus:border-transparent dark:text-white" data-id="element-2572" />)}
        </div>

        <Button onClick={handleVerify} disabled={otp.join('').length !== 6} className="w-full bg-primary hover:bg-primary/90 text-white py-4 rounded-xl font-semibold mb-6 disabled:opacity-50" data-id="element-2573">
          Verify & Continue
        </Button>

        <div className="text-center" data-id="element-2574">
          <p className="text-sm text-gray-500 dark:text-gray-400" data-id="element-2575">
            Didn't receive the code?
          </p>
          {timeLeft > 0 ? <p className="text-sm font-medium text-gray-900 dark:text-gray-300 mt-1" data-id="element-2576">
              Resend code in <span className="text-primary" data-id="element-2577">{timeLeft}s</span>
            </p> : <button onClick={() => setTimeLeft(60)} className="text-sm font-medium text-accent mt-1" data-id="element-2578">
              Resend Code
            </button>}
        </div>
      </div>
    </div>;
}